"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PVote = void 0;
var pstruct_1 = require("../../../PTypes/PStruct/pstruct.js");
exports.PVote = (0, pstruct_1.pstruct)({
    No: {},
    Yes: {},
    Abstain: {}
});
